// Polling configuration for sync behavior. Configure via env var:
// REACT_APP_POLL_INTERVAL_MS (milliseconds). Default: 5000 (5s).
export const POLL_INTERVAL_MS = (() => {
  try {
    const v = parseInt(process.env.REACT_APP_POLL_INTERVAL_MS, 10)
    if (!isNaN(v) && v > 0) return v
  } catch (e) {}
  return 5000
})()

// Polling interval for the website notification bell. Configure via env var:
// REACT_APP_NOTIFICATIONS_POLL_INTERVAL_MS (milliseconds). Default: 12000 (12s).
export const NOTIFICATIONS_POLL_INTERVAL_MS = (() => {
  try {
    const v = parseInt(process.env.REACT_APP_NOTIFICATIONS_POLL_INTERVAL_MS, 10)
    if (!isNaN(v) && v > 0) return v
  } catch (e) {}
  return 12000
})()
